// Validación local de documentos peruanos (mismo criterio que el backend,
// icard/peru_docs.py): da el aviso al instante, sin consultar a nadie.
const RUC_FACTORS = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];

export function isValidRuc(ruc) {
  const value = String(ruc || "").trim();
  if (!/^(10|15|17|20)\d{9}$/.test(value)) return false;
  const total = RUC_FACTORS.reduce((sum, factor, i) => sum + Number(value[i]) * factor, 0);
  let check = 11 - (total % 11);
  if (check === 10) check = 0;
  if (check === 11) check = 1;
  return check === Number(value[10]);
}

export const isValidDni = (dni) => /^\d{8}$/.test(String(dni || "").trim());
